import * as React from "react";
import { Dialog } from "@progress/kendo-react-dialogs";
import { Form, Field, FormElement } from "@progress/kendo-react-form";
import { Input, Checkbox } from "@progress/kendo-react-inputs";
import { Label } from "@progress/kendo-react-labels";
import { Button } from "@progress/kendo-react-buttons";
import SubmitButton from "components/common/SubmitButton";

const validateForm = (values) => {
  const errors = {};

  if (!values.sourceName?.trim()) {
    errors.sourceName = "Source name is required";
  }

  return errors;
};

const AddEditSource = (props) => {
  const ADD_NEW = props.type === "addNew";
  const [submitAttempted, setSubmitAttempted] = React.useState(false);

  return (
    <Dialog
      title={ADD_NEW ? "Add Source" : `Edit ${props?.item?.sourceName}`}
      onClose={props.cancelEdit}
      width={600}
    >
      <Form
        onSubmit={props.onSubmit}
        initialValues={{ active: true, ...props.item }}
        validator={validateForm}
        render={(formRenderProps) => (
          <>
            <FormElement
              style={{
                maxWidth: 1200,
              }}
            >
              <fieldset className={"k-form-fieldset p-3 ps-4"}>
                <div className="mb-2">
                  <Label className="label mt-1 mb-2 w-100">Name&nbsp;</Label>
                  <Field
                    name={"sourceName"}
                    component={Input}
                    placeholder="Enter Name"
                  />
                  {submitAttempted && formRenderProps.errors?.sourceName && (
                    <div className="fs-sm my-1 text-danger">
                      <i>{formRenderProps.errors.sourceName}</i>
                    </div>
                  )}
                </div>
                <div className="mb-2">
                  <Label className="label mt-1 mb-2 w-100">Details&nbsp;</Label>
                  <Field
                    name={"sourceDetails"}
                    component={Input}
                    placeholder="Enter Details"
                  />
                </div>
                <Field
                  name="active"
                  className="mt-2"
                  component={Checkbox}
                  label={"Active"}
                />
              </fieldset>
            </FormElement>
            <div className="dialog-footer">
              <Button
                className="common-btn bgBtnSecondary me-2"
                onClick={props.cancelEdit}
              >
                Cancel
              </Button>
              <SubmitButton
                className="me-3"
                onClick={() => {
                  setSubmitAttempted(true);
                  formRenderProps.onSubmit();
                }}
                disabled={!formRenderProps?.allowSubmit}
                isLoading={props.isSubmitting}
              >
                {ADD_NEW ? "Save" : "Update"}
              </SubmitButton>
            </div>
          </>
        )}
      />
    </Dialog>
  );
};

export default AddEditSource;
